import createStore from "view-ui-admin/src/utils/create-store";
import Model from "@/models/admin/withdraws";

export default createStore({ Model });
